export const safeFormatTotalScore = userExam =>
  userExam.exam.questions.length > 0
    ? `${(
        (userExam._totalScore / userExam.exam.questions.length) *
        100
      ).toFixed(0)}%`
    : `N/A`;
